import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '../src/utils/translations';
// import 'bootstrap/dist/css/bootstrap.min.css';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import ErrorBoundary from './components/ErrorBoundary';
import MaintenanceMode from './utils/MaintenanceMode';
import { LoadingProvider } from './LoadingContext';

const msalInstance = new PublicClientApplication(msalConfig);

// Check if root element exists, otherwise create it
let rootElement = document.getElementById('root-chatbot');
if (!rootElement) {
  rootElement = document.createElement('div');
  rootElement.id = 'root-chatbot';
  rootElement.classList.add("chatbot-container");

  // Find the parent container
  const parentContainer = document.getElementById('chatbot-container');
  if (parentContainer) {
    parentContainer.appendChild(rootElement);
  } else {
    document.body.appendChild(rootElement);
  }
}

// Create root and render the App component
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    {process.env.REACT_APP_MAINTENANCE_MODE == "true" ? (
      <MaintenanceMode />
    ) : (
      <MsalProvider instance={msalInstance}>
        <ErrorBoundary>
          <LoadingProvider>
            <App />
          </LoadingProvider>
        </ErrorBoundary>
      </MsalProvider>
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
